import React, { useRef, useEffect } from 'react';

import { IconMail, IconCloseSmall } from '@lessonnine/design-system.lib';
import InputFrame from './InputFrame';

import { t } from 'src/viewLayer/helpers/translations';

export default ({
  clearValue,
  disabled,
  errorKey,
  isFocused,
  setFocus,
  onChangeHandler,
  value
}) => {
  const EmailInputRef = useRef();

  useEffect(() => {
    if (isFocused) EmailInputRef.current.focus();
  }, [isFocused]);

  return (
    <InputFrame errorKey={errorKey} disabled={disabled} focused={isFocused}>
      <div className="icon-email">
        <IconMail />
      </div>
      <input
        id="uat-email-input-field"
        className="input-field"
        type="email"
        placeholder={ t('email.placeholder') }
        value={value}
        autoComplete="email"
        name="email"
        onChange={onChangeHandler}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        ref={EmailInputRef}
        disabled={disabled}
      />
      <div
        className={'icon-end-right ' + (value ? '' : 'hidden')}
        onClick={clearValue}
        disabled={disabled}
      >
        <IconCloseSmall />
      </div>
    </InputFrame>
  );
};
